import { useState } from "react";
import { CONTRACT_NAME, currentApiList, mainnetApiList, v2DAOContract } from "../../data/config";
import axios from 'axios';
import { CONTRACT_PUBLIC_KEY, CONTRACT_PUBLIC_KEY_OLD_FORMAT } from "../../data/constants";

const checkPermissions = (permissions, permName, linkedAction, requiredAuth, requiredAuthOld) => {
    return permissions.some(permission => {
        if (permission.perm_name !== permName) return false;

        const hasCorrectKey = permission.required_auth.keys.some(key =>
            (key.key === requiredAuth.key || key.key === requiredAuthOld.key) && key.weight === requiredAuth.weight
        );
        if (!hasCorrectKey) return false;
        
        if (!permission.required_auth.accounts.some(account =>
            account.permission.actor === requiredAuth.actor && account.permission.permission === requiredAuth.permission)) return false;

        if (!permission.linked_actions.some(action =>
            action.account === linkedAction.account && action.action === linkedAction.action)) return false;

        return true;
    });
};



export const useCheckPermissions = () => {
    
    const [hasPermission, setHasPermission] = useState(false);
    const [permissionIsLoading, setPermissionIsLoading] = useState(true);

    const getPermission = async (name) => {
        setPermissionIsLoading(true);
        setHasPermission(false);
    
        const permName = "newaccount";
        const linkedAction = { account: "eosio", action: "newaccount" };
        const requiredAuth = {
            actor: CONTRACT_NAME,
            permission: "eosio.code",
            key: CONTRACT_PUBLIC_KEY,
            weight: 1
        };

        const requiredAuthOld = {
            key: CONTRACT_PUBLIC_KEY_OLD_FORMAT,
            weight: 1
        };
        
        
   
    
        for (const api of currentApiList) {
            try {
                const res = await axios.post(`${api}/v1/chain/get_account`,{
                    account_name: name,
                    json: true,
                });
    
                if (res.data.permissions) {
                    console.log(res.data.permissions)
                    const hasRequiredPermissions = checkPermissions(res.data.permissions, permName, linkedAction, requiredAuth, requiredAuthOld);
                    if (hasRequiredPermissions) {
                        setHasPermission(true);
                        console.log("good to go")
                        break;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
        setPermissionIsLoading(false);
    }

    return [hasPermission, getPermission, permissionIsLoading]
}
